import {
    centeredLine, createDefaultMaterial,
    getMetaNumber,
    getOffsetsAfterRotation, InitialStruct,
    JoinPlane,
    JoinType,
    JoinVariant,
    Line2,
    matBeam, ParamsGetSimpleBoard, RenderElement,
    RenderStruct, simpleSize, Vec3
} from "@3dcalc/3dpClient";
import {CP, IP} from "../setting/initParam";
import {api} from "../api/api";
import {SpecStructElement, StructData} from "@3dcalc/3dpClient/dist/types/renderElements";
import {locale} from "../setting/locale";


export async function getF5(s:InitialStruct, sBoard:simpleSize, modeBuild: boolean = false): Promise<StructData> {

    const paramsGetSimpleBoard: ParamsGetSimpleBoard = {
        modeBuild: modeBuild,
        shift: {back: 0, front: 0},
        sizeBoard: {w: sBoard.w, h: sBoard.h, l:  sBoard.l},
        cuts: [],
        joinStart: {
            joinType: JoinType.End,
            joinPlane: JoinPlane.Bottom,
            indent: 0,
            angle: 90-s.a,
            variant: JoinVariant.Angle,
        },
    }
    const rs:RenderStruct = {
        vertices: [],
        indices: [],
        uvs: [],
        material: [],
        elements: [],
        group: ''
    }
    const spec: SpecStructElement[] = []
    const specIds: string[] = []
    rs.material.push(createDefaultMaterial())
    const resultGetSimpleBoard = await api.getSimpleBoard.build(paramsGetSimpleBoard)
    rs.uvs.push(resultGetSimpleBoard.mesh.uvs)
    const numUvs = rs.uvs.length - 1
    rs.indices.push(resultGetSimpleBoard.mesh.indices)
    const numIndices = rs.indices.length - 1
    rs.vertices.push(resultGetSimpleBoard.mesh.vertices)
    const numVertices = rs.vertices.length - 1
    const nameGroup = IP.elementData.f5.groupName || 'trust'
    const nameElement = IP.elementData.f5.name || 'f5'
    rs.group = nameGroup

    const meta = resultGetSimpleBoard.meta

    const realSeg = centeredLine(CP.maps.f1.lineCut, s.l)

    const metaJEOffset1End = getMetaNumber(meta.modify, "joinEnd", "offset1")
    const metaJEOffset2End = getMetaNumber(meta.modify, "joinEnd", "offset2")
    const metaJEOffsetStart = getMetaNumber(meta.modify, "joinStart", "offset")

    const line2:Line2 = [[meta.h, 0], [meta.h, meta.l - metaJEOffset2End]]
    const line1:Line2 = [[meta.h / 2, meta.l / 2],[meta.h / 2, meta.l]]
    const line3:Line2 = [[0, 0 + metaJEOffsetStart], [0, meta.l - metaJEOffset1End]]

    const p:Line2[] = [line1, line2, line3]
    const specID = nameElement
    for (let i = 0; i < realSeg.length; i++) {
        const x = realSeg[i][0]

        const z = s.h
            - IP.gash.simple
            - IP.gash.simple
            + IP.elementData.f1.sizeBoard.h
            + meta.l / 2

        const yR = 0
            - IP.elementData.f2.sizeBoard.w
            - CP.maps.f4.point[0]

        const yL = 0
            + IP.elementData.f2.sizeBoard.w / 2
            + IP.elementData.f5.sizeBoard.w / 2
            + CP.maps.f4.point[0]

        const posR:Vec3 = [x, z, yR]
        const posL:Vec3 = [x, z, yL]

        const boardR: RenderElement = {
            indices: numIndices,
            name: `${nameGroup} - ${i}`,
            nameGroup: nameGroup,
            position: posR,
            rotation: [0, 0, 0],
            uvs: numUvs,
            vertices: numVertices,
            material: 0,
            specId: specID,
        }
        rs.elements.push(boardR)

        const boardL: RenderElement = {
            indices: numIndices,
            name: `${nameGroup} - ${i}`,
            nameGroup: nameGroup,
            position: posL,
            rotation: [0, Math.PI, 0],
            uvs: numUvs,
            vertices: numVertices,
            material: 0,
            specId: specID,
        }
        rs.elements.push(boardL)
    }

    spec.push({
        w: resultGetSimpleBoard.meta.w,
        h: resultGetSimpleBoard.meta.h,
        l: resultGetSimpleBoard.meta.l,
        name: nameElement,
        group: nameGroup,
        count: (realSeg.length) * 2,
        materialId: IP.elementData.f5.materialId,
        specId: specID,
    })
    specIds.push(specID)
    rs.specIds = specIds

    return {rs: rs, spec: spec}
}
